
import React from 'react';
import { Link } from 'react-router-dom';

interface AuthFooterProps {
  text: string;
  linkText: string;
  linkTo: string;
}

const AuthFooter = ({ text, linkText, linkTo }: AuthFooterProps) => {
  return (
    <div className="mt-6 text-center">
      <p className="text-gray-600">
        {text}{' '}
        <Link to={linkTo} className="text-primary-blue hover:underline">
          {linkText}
        </Link>
      </p>
    </div>
  );
};

export default AuthFooter;
